import { Playground } from '@playground';
import { Footer } from "../../../../../packages/layout/src/components/footer/footer";
import * as React from 'react';
export default {
  Playground,
  Footer,
  React
};